import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { deleteInstituteType } from '../api/instituteTypes.api';

export function useDeleteInstituteType() {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: (id: number) => deleteInstituteType(id),
    onSuccess: () => {
      void refreshRelatedData('instituteType');
      toast.success('Institute type deleted successfully');
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to delete institute type');
    },
  });
}
